import {useMutation} from '@apollo/react-hooks';

import type {
    Webcast,
    RegisterForWebcast as RegisterForWebcastMutation,
    RegisterForWebcastVariables as RegisterForWebcastMutationVariables,
} from 'nutshell-graphql-types';

import REGISTER_FOR_WEBCAST from '../graphql/mutations/demio-register.graphql';

export function useDemioRegister(): (arg1: {webcast: Webcast}) => Promise<any> {
    const [register] = useMutation<RegisterForWebcastMutation, RegisterForWebcastMutationVariables>(
        REGISTER_FOR_WEBCAST
    );

    return (input: {webcast: Webcast}) => {
        return register({
            variables: {
                registrationInput: {
                    eventRegistrationUrl: input.webcast.registrationUrl,
                    webcastId: input.webcast.id,
                },
            },
            optimisticResponse: {
                // @ts-expect-error
                __typename: 'Mutation',
                demioRegister: {
                    __typename: 'DemioRegisterPayload',
                    webcast: {
                        ...input.webcast,
                        isCurrentUserRegistered: true,
                    },
                },
            },
        });
    };
}
